<template>
  <div style="max-width: 100%">
    <v-menu v-if="path && !isPurged" open-on-hover top offset-y max-width="400" open-delay="500">
      <template #activator="{ on }">
        <v-img class="fs-exclude" :src="path" contain :max-height="block ? 200 : 40" :max-width="block ? undefined : 200" width="100%" position="left" alt="" v-on="on" />
      </template>

      <v-card tile elevation="12" width="350">
        <v-img class="fs-exclude" :src="path" contain alt="" />
      </v-card>
    </v-menu>
    <span v-if="path && isPurged" class="font-italic">Image not available</span>
    <v-btn v-if="!path && !isProviderSupplied && canUpdate" class="no-transform px-0 mx-auto" text :to="`./translate?step=select&markupId=${markupId}`">
      <span class="body-2">Select field from image <v-icon size="20" class="ml-2">crop</v-icon></span>
    </v-btn>
    <span v-if="(!path && !isProviderSupplied && !canUpdate)" class="body-2">
      (Not Supplied)
    </span>
    <span v-if="isProviderSupplied" class="body-2">
      (Provider Supplied)
    </span>
  </div>
</template>

<script>
export default {
  props: {
    block: { type: Boolean, default: false },
    markupId: { type: Number, required: true },
    isPurged: { type: Boolean, default: false },
    path: { type: String, default: '' },
    canUpdate: { type: Boolean, default: true },
    isProviderSupplied: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
  .no-transform {
    text-transform: none;
  }
</style>
